<template lang="pug">
modal#delete-archive-modal(
  :buttonColor='true'
  :close-button-label='$t("modal.deleteArchive.closeButtonLabel")'
  :process-button-label='$t("modal.deleteArchive.processButtonLabel")'
  :title='$t("modal.deleteArchive.title")'
  @process='deleteArchive'
  processButtonClass='btn-danger'
  ref='modal'
)
  p.text-left {{ $t('modal.deleteArchive.message1') }}
    strong {{ $t('modal.deleteArchive.message2') }}
    | {{ $t('modal.deleteArchive.message3') }}
  .text-center.mt-4
    img.img-fluid.mb-4(src='/img/ilustrations/delete-archive.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import StorageHttp from '@/services/StorageHttp';
import alert from '@/modules/account/common/alert';

export default {
  name: 'DeleteArchiveModal',
  components: {
    Modal,
  },
  data() {
    return {
      buttonColor: true,
    };
  },
  props: {
    archiveId: {
      type: String,
      required: true,
      default: '',
    },
  },
  methods: {
    deleteArchive() {
      this.$loading(true);
      StorageHttp.supressDefault = true;
      StorageHttp.removeItem(this.archiveId)
        .then((res) => {
          if (res.status === 204) {
            alert.fireAlert(this.$t('modal.deleteArchive.successMessage'), {
              classes: 'alert-success',
              styles:
                'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
              icon: 'circle-check',
            });
          }
          this.$emit('deleted');
        })
        .catch((err) => {
          if (err.response.status === 404) {
            alert.fireAlert(this.$t('modal.deleteArchive.errorMessage'), {
              classes: 'alert-danger',
              styles:
                'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
              icon: 'triangle-exclamation',
            });
          }
        })
        .finally(() => {
          this.$refs.modal.close();
          this.$loading(false);
        });
    },
  },
};
</script>
